<template>
  <span fluid>
    <v-card class="card--flex-toolbar">
      <v-card-title class="blue-grey lighten-5">
        <h2>Cadastro de Departamentos</h2>
        <v-spacer></v-spacer>
        <v-btn @click="onNewButtonClick()" small color="primary">Novo</v-btn>
      </v-card-title>
      <v-card-text>
        <e-data-table
          :headers="headers"
          :items="departamentos"
          :total="total"
          :hideSearch="true"
          @refresh="getAll"
          @edit="editItem"
          @delete="deleteItem"
        ></e-data-table>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
  </span>
</template>
<script>
import EDataTable from '@/components/EDataTable'
import { showError, showConfirm, retPermissao } from '@/utils'
import departamentosService from '@/services/departamentos'

export default {
  name: 'departamentos',
  components: {
    EDataTable
  },
  data () {
    return {
      departamentos: [],
      total: 0,
      headers: [
        { text: 'Descrição', value: 'descricao', sortable: false }],
      valid: true,
      rules: {
        descricao: [v => !!v || 'Campo Requerido']
      },
      buttonSaveLoadingVisible: false
    }
  },

  methods: {
    async getAll (page, search) {
      try {
        const result = search === '' ? await departamentosService.getAll(page) : await departamentosService.getByNome(search, page)
        this.total = result._meta.total_items
        this.departamentos = result.data
      } catch (error) {
        this.departamentos = []
        showError(error)
      }
    },
    editItem (item) {
      var ret = retPermissao('Departamentos', 'alterar')
      if (ret === true) {
        this.$router.push(`/departamentos/editar/${item.id}`)
      }
    },
    async deleteItem (item) {
      var ret = retPermissao('Departamentos', 'excluir')
      if (ret === true) {
        showConfirm(`Tem certeza que deseja remover departamento ` + item.descricao + ` ?`, async result => {
          if (result) {
            try {
              this.loading = true
              await departamentosService.delete(item.id)
              this.getAll(1, '')
            } catch (error) {
              showError(error)
            } finally {
              this.loading = false
            }
          }
        })
      }
    },
    onNewButtonClick () {
      var ret = retPermissao('Departamentos', 'incluir')
      if (ret === true) {
        this.$router.push(`/departamentos/criar`)
      }
    }
  }
}
</script>
